import { Flex, Row } from '@/components';
import type { FC } from 'react';
import { AccountingTypeColField } from '../_common/fields/AccountingTypeColField';
import { AccountingTypeIdsColField } from '../_common/fields/AccountingTypeIdsColField';
import { CategoriesColField } from '../_common/fields/CategoriesColField';
import { ImplementationMethodsColField } from '../_common/fields/ImplementationMethodsColField';
import { KeywordColField } from '../_common/fields/KeywordColField';
import { NestedOrganizationIdsColField } from '../_common/fields/NestedOrganizationIdsColField';
import { NestedPolicyIdsColField } from '../_common/fields/NestedPolicyIdsColField';
import { PaymentColField } from '../_common/fields/PaymentColField';
import { ProjectNumbersColField } from '../_common/fields/ProjectNumbersColField';
import { FiscalYearColField } from './fields/FiscalYearColField';
import { FundSheetTypeColField } from './fields/FundSheetTypeColField';
import { IsPublishedColField } from './fields/IsPublishedColField';
import { SheetTypeColField } from './fields/SheetTypeColField';
import { SkipAdministrativeReformTeamEvaluationColField } from './fields/SkipAdministrativeReformTeamEvaluationColField';

type Props = {
  resetCount: number;
  onResetPayment: () => void;
};

export const BasicSearch: FC<Props> = ({ resetCount, onResetPayment }) => {
  return (
    <Flex vertical>
      <Row gutter={16}>
        <FiscalYearColField />
        <SheetTypeColField />
        <FundSheetTypeColField />
      </Row>
      <Row gutter={16}>
        <KeywordColField />
        <NestedOrganizationIdsColField />
        <PaymentColField
          resetCount={resetCount}
          onResetPayment={onResetPayment}
        />
      </Row>
      <Row gutter={16}>
        <CategoriesColField />
        <ImplementationMethodsColField />
        <NestedPolicyIdsColField />
        <AccountingTypeColField />
        <AccountingTypeIdsColField />
        <ProjectNumbersColField />
        <SkipAdministrativeReformTeamEvaluationColField />
        <IsPublishedColField />
      </Row>
    </Flex>
  );
};
